var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import { cx } from 'emotion';
import { deprecatedProp as deprecated } from './utils';
const Alert = (_a) => {
    var { type, status, message, title, dismissible, dismissed, onDismiss, className, style } = _a, rest = __rest(_a, ["type", "status", "message", "title", "dismissible", "dismissed", "onDismiss", "className", "style"]);
    const [localDismissed, setLocalDismissed] = useState(dismissed);
    useEffect(() => {
        setLocalDismissed(dismissed);
    }, [dismissed]);
    const onCloseClicked = () => {
        setLocalDismissed(true);
        onDismiss && onDismiss();
    };
    if (dismissible && localDismissed) {
        return null;
    }
    const titleElement = title ? (React.createElement("p", null,
        ' ',
        React.createElement("strong", null,
            " ",
            title,
            " "),
        ' ')) : ('');
    const dismissibleButton = dismissible ? (React.createElement("button", { type: "button", className: "close", onClick: onCloseClicked }, "\u00D7")) : ('');
    return (React.createElement("div", Object.assign({ className: cx('alert', `alert-${status || type || 'danger'}`, { 'alert-dismissible': dismissible }, className), style: style }, rest),
        dismissibleButton,
        titleElement,
        message));
};
Alert.propTypes = {
    status: PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
    message: PropTypes.node.isRequired,
    title: PropTypes.node,
    dismissible: PropTypes.bool,
    dismissed: PropTypes.bool,
    onDismiss: PropTypes.func,
    style: StylePropType,
    className: PropTypes.string,
    type: deprecated(PropTypes.oneOf(['success', 'info', 'warning', 'danger']), 'Use `status` instead.'),
};
Alert.defaultProps = {
    dismissible: true,
    dismissed: false,
    style: {},
    className: '',
};
export default Alert;
